import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {ConfigModule} from '@ngmedax/config';
import {RegistryModule} from '@ngmedax/registry';
import {ValueModule} from '@ngmedax/value';
import {ErrorModule} from '@ngmedax/error';
import {LayoutModule, LayoutService} from '@ngmedax/layout';
import {TranslationModule} from '@ngmedax/translation';
import {ThemeModule} from '@ngmedax/theme';
import {ToastModule} from '@ngmedax/toast';
import {TenantModule} from '@ngmedax/tenant';
import {LoginModule} from '@ngmedax/login';
import {PermissionModule} from '@ngmedax/permission';
import {UmsModule} from '@ngmedax/ums';

import {config} from '../config';
import {modifier} from '../modifier';
import {routing} from './app.routing';
import {UserGridRedirectComponent} from './user-grid-redirect.component';


@NgModule({
  declarations: [
    AppComponent,
    UserGridRedirectComponent
  ],
  imports: [
    /* mandatory core modules! */
    BrowserAnimationsModule,
    BrowserModule,
    RegistryModule,
    LayoutModule,
    ErrorModule,
    ValueModule,
    ToastModule.forRoot({alertHack: true, confirmHack: true}),
    ConfigModule.forConfig(config, modifier),

    /* feature modules required for tkw admin dashboard */
    TranslationModule,
    ThemeModule,
    TenantModule,
    LoginModule,
    PermissionModule,
    UmsModule,
    routing
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  public constructor(
    layoutService: LayoutService,
  ) {
    // home view of the tkw dashboard is the user grid (admins only manage users here).
    // a tiny redirect component is used so the browser ends up on /module/ums/user/grid.
    layoutService.setHomeComponent(UserGridRedirectComponent);
  }
}
